export default __webpack_public_path__ + "static/Sleep  A Perfect Way To Regulate Emotions And Health-c5cded709b20a763656a4565bc028ee7.jpg";